import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi, portalApi, getToken, setToken, clearToken } from "./api";

const AdminAuthContext = createContext(null);
const ActorAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest
  const [error, setError] = useState(null);

  useEffect(() => {
    const t = getToken("admin");
    if (!t) { setUser(null); return; }
    adminApi.get("/auth/me").then(({ data }) => setUser(data)).catch(() => { clearToken("admin"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.token, "admin");
      setUser(data.user);
      return true;
    } catch (e) {
      const msg = e?.response?.data?.detail;
      setError(typeof msg === "string" ? msg : (Array.isArray(msg) ? msg[0]?.msg : "Login failed"));
      return false;
    }
  };

  const logout = () => { clearToken("admin"); setUser(null); };

  return (
    <AdminAuthContext.Provider value={{ user, login, logout, error }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
export const useAdminAuth = () => useContext(AdminAuthContext);

export function ActorAuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [error, setError] = useState(null);

  useEffect(() => {
    const t = getToken("actor");
    if (!t) { setUser(null); return; }
    portalApi.get("/portal/me").then(({ data }) => setUser(data)).catch(() => { clearToken("actor"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await portalApi.post("/portal/login", { email, password });
      setToken(data.token, "actor");
      setUser(data.user);
      return true;
    } catch (e) {
      const msg = e?.response?.data?.detail;
      setError(typeof msg === "string" ? msg : "Login failed");
      return false;
    }
  };

  const logout = () => { clearToken("actor"); setUser(null); };

  return (
    <ActorAuthContext.Provider value={{ user, login, logout, error }}>
      {children}
    </ActorAuthContext.Provider>
  );
}
export const useActorAuth = () => useContext(ActorAuthContext);
